import axios from "axios";
let axiosClient;

export default axiosClient = axios.create({
  headers: {
    Accept: 'application/json',
    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    'Content-Type': 'application/json'
  } 
})